import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import qs from 'qs';
import PasswordResetFormContainer from '../PasswordResetForm';
import styles from './styles.scss';


const PasswordResetPage = ({ search }) => {
  const query = qs.parse(search, {
    ignoreQueryPrefix: true
  });
  const {
    userId,
    code=''
  } = query;

  return (
    <div className='col'>
      <img src='/logo.jpg' className={styles.logo} />
      <h1 className={styles.header}>
        Radon Management Cloud
      </h1>
      <PasswordResetFormContainer
        userId={userId}
        code={code.replace(/ /gi, '+')}
      />
      <Link to='/login'>
        Go to Login
      </Link>
    </div>
  );
};

PasswordResetPage.propTypes = {
  search: PropTypes.string
};

export default PasswordResetPage;


// WEBPACK FOOTER //
// src/components/login/PasswordResetPage/index.jsx